/**
 * Baseline constants for rem calculations
 * These values define the base font size used for rem calculations throughout the application
 */
export const BASELINE_CONSTANTS = {
    DEFAULT_FONT_SIZE: 16,

    REM_BASELINE_PROPERTY: "--w-rem-baseline",

    DEFAULT_BASELINE_CSS: "16px",
} as const;
